import { render, staticRenderFns } from "./OrderTransactionsCard.vue?vue&type=template&id=5a253092&scoped=true&"
import script from "./OrderTransactionsCard.vue?vue&type=script&lang=js&"
export * from "./OrderTransactionsCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderTransactionsCard.vue?vue&type=style&index=0&id=5a253092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a253092",
  null
  
)

export default component.exports